import { EngagementProcess } from '../slices/marketplace/timeline/models/engagement-process.model';
import { EngagementBuyer } from '../slices/marketplace/timeline/models/engagement-buyer.model';

/**
 * The backend computes IsFlowOfFundsAvailable per buyer (FlowOfFundsAccessRules) — this just
 * reads that computed flag off the winning buyer rather than re-deriving the rule client-side.
 */
export const isFlowOfFundsAvailable = (
    engagementProcess: EngagementProcess | null | undefined
): boolean =>
    engagementProcess?.buyers?.some((buyer) => buyer.isFlowOfFundsAvailable) ?? false;

export const getWinningBuyer = (
    engagementProcess: EngagementProcess | null | undefined
): EngagementBuyer | undefined =>
    engagementProcess?.buyers?.find((buyer) => buyer.isLoiSelected);
